import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../../data/content";
import { useKaramiko } from "./context";

export default function Navbar() {
  const { found, totalMonkeys } = useKaramiko();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const count = found.size;
  const complete = count === totalMonkeys;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-40 transition-all duration-300 ${
        scrolled ? "bg-kraft/90 backdrop-blur-md paper-shadow" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3">
        <button onClick={() => go("inici")} className="hover-wiggle" data-testid="nav-logo" aria-label="Karamiko inici">
          <img src="/logo-wordmark.png" alt="Karamiko" className="h-10 w-auto sm:h-12" />
        </button>

        <div className="hidden items-center gap-7 md:flex">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              className="link-draw font-body text-sm font-bold text-forest"
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3">
          {/* joc: micos amagats trobats */}
          <motion.div
            key={count}
            initial={{ scale: 0.85 }}
            animate={{ scale: complete ? [1, 1.15, 1] : 1 }}
            transition={{ type: "spring", stiffness: 300, damping: 12 }}
            className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 ${complete ? "bg-terracotta/20 text-terracotta" : "bg-sage/20 text-forest"}`}
            title="Micos amagats: toca els panells per trobar-los!"
            data-testid="monkey-counter"
          >
            <span className="text-base leading-none" role="img" aria-label="mico">🐒</span>
            <span className="font-display text-sm font-semibold">{count}/{totalMonkeys}</span>
            {complete && <span className="text-base leading-none" role="img" aria-label="festa">🎉</span>}
          </motion.div>

          <button
            className="md:hidden text-forest"
            onClick={() => setOpen((o) => !o)}
            aria-label="Menú"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </nav>

      {open && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          className="overflow-hidden bg-kraft/95 backdrop-blur-md md:hidden"
          data-testid="mobile-menu"
        >
          <div className="flex flex-col px-5 pb-4">
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                onClick={() => go(l.id)}
                className="border-b border-kraft-dark py-3 text-left font-body font-bold text-forest"
                data-testid={`mobile-nav-link-${l.id}`}
              >
                {l.label}
              </button>
            ))}
          </div>
        </motion.div>
      )}
    </header>
  );
}
